<template>
   <component
      :is="href ? RouterLink : 'div'"
      :to="href || undefined"
      class="rounded-base relative overflow-hidden bg-white"
      :class="{
         '__shadow border-transparent': !loading && shadow,
         'border-light-grey border': !shadow,
         __clickable: !!href || $attrs.onClick,
      }"
   >
      <Skeleton :loading="loading" height="100%" width="100%">
         <div
            class="border-primary rounded-base pointer-events-none absolute inset-0 border-2 bg-black/10 opacity-0 transition-all group-hover:opacity-100"
            :class="{
               'bg-primary/30 pointer-events-none opacity-100': selected,
            }"
         />
         <slot />
      </Skeleton>
   </component>
</template>

<script lang="ts" setup>
import { RouterLink } from 'vue-router'

type Props = {
   loading?: boolean
   selected?: boolean
   shadow?: boolean
   href?: string
}

const props = withDefaults(defineProps<Props>(), {
   shadow: true,
})
</script>
